(() => {
  const drawer = document.getElementById('t4s-menu-drawer');
  if (!drawer) return;
  let opener = null;
  let active = false;
  let background = [];
  const focusables = () => Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),summary,[tabindex="0"]')).filter(el => el.getClientRects().length && !el.closest('[hidden]') && getComputedStyle(el).visibility !== 'hidden');
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-menu-drawer]');
    if (trigger && !drawer.contains(trigger)) opener = trigger;
  }, true);
  const sync = () => {
    const menu = drawer.querySelector('.lf-mobile-menu');
    const open = drawer.getAttribute('aria-hidden') === 'false' && !!menu;
    if (menu?.dataset.label) drawer.setAttribute('aria-label', menu.dataset.label);
    if (open === active) return;
    active = open;
    if (open) {
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');

      if (!opener) opener = document.activeElement;
      background = Array.from(document.querySelectorAll('.t4s-website-wrapper')).map(el => ({el, inert: el.inert}));
      background.forEach(item => { item.el.inert = true; });
      requestAnimationFrame(() => { if (active) drawer.querySelector('.lf-menu-close')?.focus({preventScroll: true}); });
    } else {
      drawer.removeAttribute('aria-modal');
      background.forEach(item => { item.el.inert = item.inert; });
      background = [];
      if (opener?.isConnected) opener.focus({preventScroll: true});
      opener = null;
    }
  };
  new MutationObserver(sync).observe(drawer, {attributes: true, attributeFilter: ['aria-hidden'], childList: true, subtree: true});
  document.addEventListener('keydown', event => {
    if (!active) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      drawer.querySelector('.lf-menu-close')?.click();
    } else if (event.key === 'Tab') {
      const items = focusables();
      if (!items.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const position = items.indexOf(document.activeElement);
      const next = position < 0 ? (event.shiftKey ? items.length - 1 : 0) : (position + (event.shiftKey ? -1 : 1) + items.length) % items.length;
      items[next].focus();
    }
  }, true);
  drawer.addEventListener('transitionend', event => {
    if (event.target === drawer && active && !drawer.contains(document.activeElement)) drawer.querySelector('.lf-menu-close')?.focus({preventScroll: true});
  });
  sync();
})();
